import React from "react";

import logo from "./img/acy_logo.svg";
import bannerAudi from "./img/banner_audi.jpg";
import bannerMc from "./img/banner_mclaren.png";
import bannerMercedes from "./img/banner_mercedes.jpg";
import bannerAudiMid from "./img/banner_audi_mid.jpg";
import bannerMcMid from "./img/banner_mclaren_mid.png";
import bannerMercedesMid from "./img/banner_mercedes_mid.jpg";
import fixAudi from "./img/fix_audi.png";
import fixMc from "./img/fix_mclaren.png";
import fixMercedes from "./img/fix_mercedes.png";
import fixCash from "./img/fix_cash.png";
import fixGold from "./img/fix_gold.png";
import fixHublot from "./img/fix_hublot.png";
import fixIphone from "./img/fix_iphone.png";
import smallAudi from "./img/small_audi.png";
import smallMc from "./img/small_mclaren.png";
import smallMercedes from "./img/small_mercedes.png";
import smallCash from "./img/small_cash.png";
import smallGold from "./img/small_gold.png";
import smallHublot from "./img/small_hublot.png";
import smallIphone from "./img/small_iphone.png";
import mcLarenLogo from "./img/mclaren_logo.svg";
import mercedesLogo from "./img/mercedes_logo.svg";
import audiLogo from "./img/audi_logo.svg";
import hublotLogo from "./img/hublot_logo.svg";
import rolexLogo from "./img/rolex_logo.svg";
import goldLogo from "./img/gold_logo.svg";
import iphoneLogo from "./img/iphone_logo.svg";
import howTo1 from "./img/how_to_1.svg";
import howTo2 from "./img/how_to_2.svg";
import howTo3 from "./img/how_to_3.svg";
import howTo4 from "./img/how_to_4.svg";
import howTo5 from "./img/how_to_5.svg";
import icon1 from "./img/icon1.svg";
import icon2 from "./img/icon2.svg";
import icon3 from "./img/icon3.svg";
import icon4 from "./img/icon4.svg";
import icon5 from "./img/icon5.svg";
import icon6 from "./img/icon6.svg";
import reasonsImg from "./img/reasons_bg.png";
import enFlag from "./img/en_flag.svg";
import zhFlag from "./img/zh_flag.svg";
import idFlag from "./img/id_flag.svg";
import arFlag from "./img/ar_flag.svg";
import esFlag from "./img/es_flag.svg";
import viFlag from "./img/vi_flag.svg";
import { getAcyCloudUrl } from "./getCreateAccLink";

const baseUrl =
  process.env.REACT_APP_DOMAIN === "acy-ch.com"
    ? "https://acycn.cloud"
    : "https://acy.cloud";

const pageDomain = process.env.REACT_APP_DOMAIN
  ? process.env.REACT_APP_DOMAIN
  : window.location.host;

export const data = {
  en: {
    // ###############################################################
    // ###############################################################
    // ###############################################################
    // ###############################################################
    // ###############################################################
    // ###############################################################
    // ###############################################################
    // ###############################################################
    // ###############################################################
    banner: {
      spin_now: "Spin Now",
      title:
        "Join Our Spin and Win Promotion and You Could Take Home Iconic Cars, Cash, or Gold",
      subtitle: "Double your Chance to Win Before the End of July 2024",
      logo,
      cars: [
        {
          title: "McLaren GT",
          img: bannerMc,
          img_mid: bannerMcMid,
        },
        {
          title: "Mercedes-Benz G-Class",
          img: bannerMercedes,
          img_mid: bannerMercedesMid,
        },
        {
          title: "Audi RS 5 Coupé",
          img: bannerAudi,
          img_mid: bannerAudiMid,
        },
      ],
      lang_select: [
        {
          img: enFlag,
          text: "English",
        },
        {
          img: zhFlag,
          text: "中文",
        },
        {
          img: arFlag,
          text: "العربية",
        },
        {
          img: idFlag,
          text: "Bahasa",
        },
        {
          img: esFlag,
          text: "Español",
        },
        {
          img: viFlag,
          text: "Tiếng Việt",
        },
      ],
    },
    new_prizes: {
      title: "Awe-inspiring new prizes that make a statement",
      subtitle:
        'On offer this year is the breathtakingly beautiful McLaren GT, the legendary Mercedes "G-Class", the magnificent Audi RS 5 Coupe, the stylish Rolex watch, 10 ounces of Australian gold bars, Apple iPhone 16 Pro and multiple cash prizes of US$30, US$50, US$100, and US$500',
      bottom_title: "Every spin wins a prize",
      bottom_subtitle: "Minimum US$30 (in your base currency) is guaranteed",
      spin_now: "Spin Now",
      prizes: [
        smallMc,
        smallMercedes,
        smallAudi,
        smallHublot,
        smallGold,
        smallIphone,
        smallCash,
      ],
    },
    cars: [
      {
        title: "McLaren GT",
        price: "US $224,400*",
        logo: mcLarenLogo,
        img: fixMc,
      },
      {
        title: "Mercedes-Benz G-Class",
        price: "US $149,400*",
        logo: mercedesLogo,
        img: fixMercedes,
      },
      {
        title: "Audi RS 5 Coupé",
        price: "US $80,695*",
        logo: audiLogo,
        img: fixAudi,
      },
    ],
    other_prizes: [
      {
        title: "Submariner Date",
        price: "US$26,000*",
        img: fixHublot,
        logo: rolexLogo,
        class_name: "hublot",
      },
      {
        title: "10 ounces of Gold",
        price: "US$23,000*",
        img: fixGold,
        logo: goldLogo,
        class_name: "gold",
      },
      {
        title: "iPhone 16 Pro 512GB",
        price: "US$1,300*",
        img: fixIphone,
        logo: iphoneLogo,
        class_name: "iphone",
      },
      {
        title: "Cash Prizes",
        price: "US$30, US$50, US$100 and US$500",
        img: fixCash,
        class_name: "cash",
      },
    ],
    how_to: {
      title: "How to participate in Spin & Win",
      subtitle: "Follow these five easy steps.",
      bottom1:
        "Spin & Win is available exclusively to clients of ACY Securities (ACY LTD) only.",
      bottom2: "All pictures shown are for illustration purpose only.",
      cards: [
        {
          img: howTo1,
          text: `If you’re not already a client, <a href="${getAcyCloudUrl(
            "en"
          )}" target="__blank">open a trading account</a> with ACY Securities.`,
        },
        {
          img: howTo2,
          text: 'Create a Finlogix account. <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
        },
        {
          img: howTo3,
          text: "Connect your Finlogix account to your ACY Securities trading account by a simple click",
        },
        {
          img: howTo4,
          text: `Deposit $2000 via your <a href="${getAcyCloudUrl(
            "en"
          )}" target="__blank">ACY Client Portal</a>`,
        },
        {
          img: howTo5,
          text: `Click the wheel icon inside your <a href="${getAcyCloudUrl(
            "en"
          )}" target="__blank">ACY Client Portal</a> and take your spin`,
        },
      ],
    },
    wheel: {
      lang: "en",
      title: "Spin it, to win it",
      subtitle: "Login to your ACY Securities account or Register.",
      spin: "Spin & Win",
      login: "Login",
      openAccount: "Open an account",
      logout: "Logout",
      connect_btn: "Connect",
      connect:
        "You haven't connect Finlogix, please click the connect button to sign up to Finlogix in one simple step ",
      hi: "Hi",
      click_btn: "Click the button to start spinning and winning.",
      left: "left",
      you_have: "You have",
      chance: "chance",
      chances: "chances",
      spin_min_deposite: "Minimum Deposit Required",
      spin_prize: "Prize",
      special_promo_title: "Special Spin & Win Offer​",
      special_promo_content: [
        "Special Spin & Win Offer period is from 1/3/2024 to 31/7/2024.​",
        "Clients who deposit $2,000 or more (in their account’s base currency), will earn 1 spin in the same month.",
        "A second deposit of $2,000 or more (in their account’s base currency) in the same calendar month, will earn another 1 spin. Limit of 2 spins per month applies during this promotion period.",
        "The second spin is granted under the same terms and conditions as the first spin.",
        "ACY LLC reserves the right for final prize determinations.",
        "2 spins per month",
        "Minimum win of US$30 per spin",
        "Minimum deposit varies based on the base currency of your trading account (see table above)",
      ],
      limit: "2 spins per month",
      minimum_win: "Minimum win of US$30 per spin",
      minimum_deposite:
        "Minimum deposit varies based on the base currency of your trading account (see table above)",
      switch_btn: "Switch account to spin",
      // download_Terms: 'Download Terms & Conditions',
      terms: `*<a href='https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms.pdf' target="__blank">T&Cs</a> apply. Trading involves risk. ACY Capital LLC. 2610 LLC 2022. Australian residents are ineligible for this offer.`,
      deposit_pop: {
        title: "Oh no, you can't spin just yet",
        p1: "Clients who deposit at least US$2,000 (or equivalent) are eligible to spin.",
        p2: "Every spin wins a prize!",
        button: "Make a deposit now",
      },
      connect_finlogix_pop: {
        title: "Connect to Finlogix",
        p1: "To participate in the Spin and Win 2024, you need to create an account with Finlogix.",
        p2: " FInlogix is a free social trading community for traders, and has partnered with ACY Securities.",
        p3: "Click the button below to sign up to Finlogix in one simple step.",
        button: "Sign up to Finlogix",
        lang: "en",
      },
      congratulations_pop: {
        title: "Congratulations!",
        subtitle: "You have won a",
        p1: "Please check your email for the next steps to claim your prize.",
      },
      error_messages: {
        "-101": "Unfortunately, this promotion has ended.",
        "-102":
          "You have already used the opportunities for the lucky draw this month, there will be a surprise next month!",
        "-103":
          "The prize has been drawn out. To avoid miss out, please check the website for notifications about future promotions!",
        "-105": "server error",
        429: "too many requests",
      },

      not_start: "The start time of the campaign is",
      please_wait: "Please wait.",

      prize_name: {
        mclaren: "McLaren GT",
        audi: "Audi RS 5 Coupé",
        mercedes: "Mercedes-Benz G-Class",
        iphone: "iPhone 16 Pro 512GB",
        watch: "Rolex Submariner Date",
        gold: "10 ounces of Gold",
        cash30: "US$30 Cash Prize",
        cash50: "US$50 Cash Prize",
        cash100: "US$100 Cash Prize",
        cash500: "US$500 Cash Prize",
      },
    },
    spin: {
      title: "Spin it, to win it",
      subtitle: "Login to your ACY Securities account or Register.",
      open_an_account: "Open an account",
      log_in: "Log in",
      tac: "Terms & Conditions",
      bottom1: "Up to two spins per month",
      bottom1: "Every spin wins a minimum of US$30",
    },
    why_trade: {
      title: "Why trade with ACY Securities",
      subtitle:
        "With trading conditions that are second to none, full suite of resources to help you grow as a trader, and a choice of over 2,200 instruments to diversify your portfolio, join ACY today and discover your edge.",
      cards: [
        {
          title: "Ultra-fast Order Processing",
          subtitle: "Under 30ms",
          img: icon1,
        },
        {
          title: "Ultra-low-cost trading",
          subtitle: "Spreads from 0.0 pips ",
          img: icon2,
        },
        {
          title: "24/5 Support",
          subtitle: "Multi-lingual support",
          img: icon3,
        },
        {
          title: "Cut-through Market Analysis ",
          subtitle: "Morning & Afternoon reports",
          img: icon4,
        },
        {
          title: "Copy Trading",
          subtitle: "Copy our best traders",
          img: icon5,
        },
        {
          title: "2,200+ CFDs",
          subtitle: "Trade on MT4, MT5 & ACY Trading Platform",
          img: icon6,
        },
      ],
    },
    reasons5: {
      title: `5 reasons to switch to ACY today`,
      img: reasonsImg,
      reasons: [
        {
          reason_title: `Trade with MT5, MT4 and our proprietary ACY Trading Platform`,
          reason_content: `Trade FX, Metals, and up to 2,200 markets with up to 1:5000 dynamic margin`,
        },
        {
          reason_title: `Start trading FX spreads from zero pips`,
          reason_content: `Spreads start from 0.0 pips | Execution speeds under 30ms`,
        },
        {
          reason_title: `Get access to the best trading tools for traders`,
          reason_content: `Economic Calendar, Capitalise.ai , Free MetaTrader Scripts, Forex VPS, Trading Widgets & More`,
        },
        {
          reason_title: `No restrictions on Expert Adviser (EAs) or high- frequency trading`,
          reason_content: `Trade the markets your way`,
        },
        {
          reason_title: `Copy Trade with one of the best copy trading tools`,
          reason_content: `Select from our top-performing traders based on your trading goals`,
        },
      ],
    },
    sign_up: {
      title: "Don’t have an account with us yet? Sign up now!",
      open_an_account: "Open an account",
    },
    footer: {
      acyau: [
        "RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. ACY Securities Pty Ltd (AFSL: 403863) provides general advice that does not consider your objectives, financial situation or needs. You should consider if you are part of our Target Market by reviewing our <a href='/en/support/terms-and-conditions'>TMD</a> and read our <a href='/en/support/terms-and-conditions'>FSG</a> and <a href='/en/support/terms-and-conditions'>PDS</a> to ensure you fully understand the risks. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions.",
        "ACY Securities Pty Ltd (A.B.N 80 150 565 781) is regulated by the Australian Securities and Investments Commission (ASIC AFSL:403863). Registered address: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL authorised us to provide financial services to Australian Residents or Businesses. ACY Securities Pty Ltd's MetaTrader 4 and MetaTrader 5 are software provided by MetaQuotes Ltd.",
        "ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) is regulated by the Financial Sector Conduct Authority (FSCA: 51008). Registered address: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA authorised us to provide financial services in terms of section 8 of the Financial Advisory and Intermediary Services.",
      ],
      acyltd: [
        "RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/en/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.",
        "ACY Capital LLC ('ACY LLC') is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.",
        "ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) is regulated by the Financial Sector Conduct Authority (FSCA: 51008). Registered address: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA authorised us to provide financial services in terms of section 8 of the Financial Advisory and Intermediary Services.",
        "For Jordanian clients, Al Bilad Securities and Investment Company (Registration No. 397, Institution No. 200027569), located at Building 11, Paris Street, Al Swifeyeh, Amman, Jordan (Al Bilad), acts as the introducing broker for ACY Capital Australia LLC (Company Number: 2610 LLC 2022). Al Bilad is licensed by the Jordan Securities Commission to provide financial services by introducing Jordanian clients to foreign brokers, while ACY LLC remains the principal and issuer of its products.",
      ],
      copyright:
        "© 2018 - 2025 ACY Securities is a brand name of ACY Securities Pty Ltd and ACY Capital LLC. All rights Reserved.",
      tac: "Terms of use ACY Securities Website",
    },
    form: {
      get_started: "Get Started",
      subtitle: "Register now for your chance to win",
      bottom_text: `
                <p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/en/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p>
                <p>ACY Capital LLC ('ACY LLC') is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>
                <p>ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) is regulated by the Financial Sector Conduct Authority (FSCA: 51008). Registered address: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA authorised us to provide financial services in terms of section 8 of the Financial Advisory and Intermediary Services.</p>
            `,
    },
  },

  zh: {
    banner: {
      spin_now: "立即抽奖",
      title: "参与幸运转盘活动，赢取豪车、黄金以及现金好礼",
      subtitle: "在2024年7月底之前，您的中奖机会翻倍",
      logo,
      cars: [
        {
          title: "迈凯伦GT",
          img: bannerMc,
          img_mid: bannerMcMid,
        },
        {
          title: "梅赛德斯-奔驰G系",
          img: bannerMercedes,
          img_mid: bannerMercedesMid,
        },
        {
          title: "奥迪RS 5 Coupe",
          img: bannerAudi,
          img_mid: bannerAudiMid,
        },
      ],
      lang_select: [
        {
          img: enFlag,
          text: "English",
        },
        {
          img: zhFlag,
          text: "中文",
        },
        {
          img: arFlag,
          text: "العربية",
        },
        {
          img: idFlag,
          text: "Bahasa",
        },
        {
          img: esFlag,
          text: "Español",
        },
        {
          img: viFlag,
          text: "Tiếng Việt",
        },
      ],
    },
    new_prizes: {
      title: "豪华大礼令人瞩目",
      subtitle:
        "今年的大奖是惊艳颜值的迈凯伦GT、有传奇之称的梅赛德斯-奔驰G系、低调奢华的奥迪RS 5 Coupe、极具风格的劳力士表、10盎司黄金、iPhone 16 Pro及多重现金奖励（$30、$50、$100以及$500不等）",
      bottom_title: "幸运转盘百分百中奖",
      bottom_subtitle: "奖品最低保证$30",
      spin_now: "立即抽奖",
      prizes: [
        smallMc,
        smallMercedes,
        smallAudi,
        smallHublot,
        smallGold,
        smallIphone,
        smallCash,
      ],
    },
    cars: [
      {
        title: "迈凯伦GT",
        price: "US $224,400*",
        logo: mcLarenLogo,
        img: fixMc,
      },
      {
        title: "梅赛德斯-奔驰G系",
        price: "US $149,400*",
        logo: mercedesLogo,
        img: fixMercedes,
      },
      {
        title: "奥迪RS 5 Coupe ",
        price: "US $80,695*",
        logo: audiLogo,
        img: fixAudi,
      },
    ],
    other_prizes: [
      {
        title: "Submariner Date",
        price: "US $26,000*",
        img: fixHublot,
        logo: rolexLogo,
        class_name: "hublot",
      },
      {
        title: "10盎司黄金",
        price: "US $23,000*",
        img: fixGold,
        logo: goldLogo,
        class_name: "gold",
      },
      {
        title: "iPhone 16 Pro 512GB",
        price: "US $1,300*",
        img: fixIphone,
        logo: iphoneLogo,
        class_name: "iphone",
      },
      {
        title: "现金奖励",
        price: "$30、$50、$100以及$500",
        img: fixCash,
        class_name: "cash",
      },
    ],
    how_to: {
      title: "如何参与幸运转盘",
      subtitle: "请遵循以下五个简单的步骤",
      bottom1: "仅ACY证券（ACY LTD）客户才能参与幸运转盘",
      bottom2: "所有图片仅供参考",
      cards: [
        {
          img: howTo1,
          text: `如果您还不是ACY证券的客户，请先<a href="${getAcyCloudUrl(
            "zh"
          )}" target="__blank">开通一个交易账户</a>。`,
        },
        {
          img: howTo2,
          text: '注册一个Finlogix方计账户。<a href="https://cn.finlogix.com/" target="__blank">cn.finlogix.com</a>',
        },
        {
          img: howTo3,
          text: "点击链接Finlogix方计与ACY证券的交易账户。",
        },
        {
          img: howTo4,
          text: `通过<a href="${getAcyCloudUrl(
            "zh"
          )}" target="__blank">客户端后台</a>ACY.Cloud入金2000账户货币。`,
        },
        {
          img: howTo5,
          text: `在<a href="${getAcyCloudUrl(
            "zh"
          )}" target="__blank">客户端后台</a>点击轮盘图标进行抽奖。`,
        },
      ],
    },
    wheel: {
      lang: "zh",
      title: "转盘抽奖，赢取奖品",
      subtitle: "登录已有的ACY证券账户或注册新的账户。",
      spin: "幸运转盘",
      login: "登录",
      openAccount: "开通账户",
      logout: "登出",
      connect_btn: "链接",
      connect:
        "如果您还没有链接Finlogix方计账户，点击“链接”按钮，简单一步链接到Finlogix方计账户。",
      hi: "您好",
      click_btn: "点击按钮进行转盘抽奖",
      left: "",
      you_have: "您还有",
      chance: "次机会",
      chances: "次机会",
      spin_min_deposite: "最低入金要求",
      spin_prize: "奖励",
      special_promo_title: "特别旋转与赢取优惠",
      special_promo_content: [
        "特别促销活动期限为2024年3月1日至2024年7月31日。",
        "客户需要入金至少$2,000账户货币将在当月获得一次抽奖机会。",
        "如果在同一个日历月内，第二次入金至少$2,000账户货币即可再获得一次抽奖机会。在此促销期间内，每个月的抽奖次数上限为2次。",
        "第二次抽奖所适用的活动条款与第一次抽奖相同",
        "ACY 证券保留最终奖品的决定权。",
        "每月两次抽奖机会",
        "每次抽奖赢取30美元",
        "最低入金金额根据您交易账户的基本货币而异（见上表）",
      ],
      limit: "每月两次抽奖机会",
      minimum_win: "每次抽奖赢取30美元",
      minimum_deposite: "最低入金金额根据您交易账户的基本货币而异（见上表）",
      switch_btn: "切换账户玩转盘",
      // download_Terms: 'Download Terms & Conditions',
      terms: `*<a href='https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms-zh.pdf' target="__blank">活动条款</a>适用。ACY Capital LLC. 2610 LLC 2022.澳大利亚居民无法参与此活动。`,
      deposit_pop: {
        title: "您还不能使用转盘抽奖",
        p1: "客户入金2000美元（或等价货币），就有机会转盘抽奖",
        p2: "幸运转盘百分百中奖",
        button: "点击此处入金",
      },
      connect_finlogix_pop: {
        title: "链接到Finlogix方计账户",
        p1: "要参与2024幸运转盘，您需要开通一个Finlogix方计账户。",
        p2: "Finlogix方计是免费交易生态社区，与ACY证券深入合作。",
        p3: "点击下方按钮，简单一步注册Finlogix方计账户。",
        button: "注册Finlogix方计账户",
        lang: "zh",
      },
      congratulations_pop: {
        title: "恭喜您！",
        subtitle: "恭喜您赢取了",
        p1: "请查看您的邮箱，进行下一步领取奖品",
      },
      error_messages: {
        "-101": "很遗憾，活动已经结束了。",
        "-102": "您已经使用了本月的抽奖机会，请静候下个月的惊喜！",
        "-103": "奖品已经抽完。 不要错过下次活动，活动详情将发布在官网公告中！",
        "-105": "系统错误",
        429: "系统繁忙",
      },

      not_start: "活动的开始时间是",
      please_wait: "请您稍等",

      prize_name: {
        mclaren: "迈凯伦GT",
        audi: "奥迪RS 5 Coupe",
        mercedes: "梅赛德斯-奔驰G系",
        iphone: "iPhone 16 Pro 512GB",
        watch: "劳力士表 Submariner Date",
        gold: "10盎司黄金",
        cash30: "30美元现金奖励",
        cash50: "50美元现金奖励",
        cash100: "100美元现金奖励",
        cash500: "500美元现金奖励",
      },
    },

    why_trade: {
      title: "ACY证券的优势",
      subtitle:
        "凭借行业领先的交易环境，全套资源助您交易，以及超过2,200种金融商品的多元化投资选择，立即加入ACY，发掘您的交易潜能。",
      cards: [
        { title: "交易極速完成", subtitle: "低于30毫秒", img: icon1 },
        { title: "超低成本交易", subtitle: "点差低至0.0", img: icon2 },
        {
          title: "交易日24小时服务",
          subtitle: "多语言服务",
          img: icon3,
        },
        {
          title: "深入的市场分析",
          subtitle: "早午间市场报告",
          img: icon4,
        },
        {
          title: "跟单交易",
          subtitle: "跟随顶尖交易者",
          img: icon5,
        },
        {
          title: "2200+差价合约",
          subtitle: "在MT4，MT5和ACY Trading Platform上交易",
          img: icon6,
        },
      ],
    },
    reasons5: {
      title: `5个选择ACY平台交易的理由`,
      img: reasonsImg,
      reasons: [
        {
          reason_title: `使用MT5，MT4和我们的专属平台ACY Trading Platform进行交易`,
          reason_content: `交易外汇、贵金属，以及多达2200种产品，享受最高1:5000的动态保证金。`,
        },
        {
          reason_title: `外汇交易点差低至零`,
          reason_content: `点差低至0.0 | 订单执行速度低于30毫秒`,
        },
        {
          reason_title: `获取为交易者打造的最佳交易工具`,
          reason_content: `财经日历、Capitalise.ai、免费MetaTrader交易脚本、VPS、交易插件等`,
        },
        {
          reason_title: `对智能交易（EAs）与高频交易没有限制`,
          reason_content: `以你自己的方式进行交易`,
        },
        {
          reason_title: `使用顶级跟单交易工具进行跟单交易`,
          reason_content: `根据交易目标选择表现最佳的交易信号`,
        },
      ],
    },
    sign_up: {
      title: "即刻申请ACY证券交易账户!",
      open_an_account: "开通账户",
    },
    footer: {
      acyau: [
        "风险提示：外汇及其他金融衍生品交易风险极高，并不适合所有投资者。您并不拥有标的资产及其任何权益。在您决定进行外汇和金融衍生品交易投资之前，我们建议您考虑您的投资目标、风险承受能力以及交易经验。ACY Securities Pty Ltd（ AFSL：403863）提供一般性建议并未将您的投资目标、财务状况和需求考虑在内。请您务必在进行交易投资前，了解您是否属于我们的目标客户，并仔细阅读目标客户分类（<a href='/zh/support/terms-and-conditions'>TMD</a>）, 金融服务指南（<a href='/zh/support/terms-and-conditions'>FSG</a>）和产品披露申明（<a href='/zh/support/terms-and-conditions'>PDS</a>）确保清楚相关风险。本网站的内容不构成投资建议，如有任何疑问，请您咨询独立专业的财务或税务的意见。",
        "ACY Securities Pty Ltd (A.B.N 80 150 565 781) 受澳大利亚证券和投资委员会 (ASIC AFSL:403863) 监管。注册地址：ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067。AFSL 授权我们向澳大利亚居民或企业提供金融服务。ACY Securities Pty Ltd 的 MetaTrader 4 和 MetaTrader 5 是由 MetaQuotes Ltd 提供的授权软件。",
        "ACY Securities SA Pty Ltd (注册号：2009/008731/07) 受南非金融行业行为监管局 (FSCA: 51008) 监管。注册地址：4 Stan Road, Sandton, Johannesburg, Gauteng, 2196。FSCA 授权我们根据《金融咨询和中介服务》第 8 条提供金融服务。",
      ],
      acyltd: [
        "风险提示：外汇及其他金融衍生品交易风险极高，并不适合所有投资者。您并不拥有标的资产及其任何权益。在您决定进行外汇和金融衍生品交易投资之前，我们建议您考虑您的投资目标、风险承受能力以及交易经验。ACY Capital LLC (Company number: 2610 LLC 2022)仅提供一般建议，并未将您的投资目标、财务状况和需求考虑在内。本网站的内容不构成个人投资建议，如有任何疑问，请您咨询独立的财务或税务专家的意见。<a href='/zh/support/terms-and-conditions'>关键信息与条款文件</a>可应要求或在注册时提供。如果本网站上有任何建议，则仅为一般建议。",
        "ACY Capital LLC (“ACY LLC”) 于圣文森特和格林纳丁斯注册成立（公司编号：2610 LLC 2022）。 注册地址：Suite 305, Griffith Corporate Centre, Beachmont, Kingstown。",
        "ACY Securities SA Pty Ltd (注册号：2009/008731/07) 受南非金融行业行为监管局 (FSCA: 51008) 监管。注册地址：4 Stan Road, Sandton, Johannesburg, Gauteng, 2196。FSCA 授权我们根据《金融咨询和中介服务》第 8 条提供金融服务。",
        "对于约旦客户，Al Bilad 证券与投资公司（注册编号：397，机构编号：200027569），位于约旦安曼 Al Swifeyeh 巴黎街 11号，负责作为 ACY Capital Australia LLC（公司编号：2610 LLC 2022）的介绍经纪商。Al Bilad 获得约旦证券委员会授权提供金融服务，推介约旦客户至外国经纪商。同时，ACY LLC 保持其作为产品主要发行方的地位。",
      ],
      copyright:
        "© 2018-2025 ACY证券是ACY Securities Pty Ltd和ACY Capital LLC的品牌名称，保留所有权利。",
      tac: "网站使用条款",
    },
    form: {
      get_started: "开始抽奖",
      subtitle: "立即注册，解锁奖品",
      bottom_text: `
                <p>风险提示：外汇及其他金融衍生品交易风险极高，并不适合所有投资者。您并不拥有标的资产及其任何权益。在您决定进行外汇和金融衍生品交易投资之前，我们建议您考虑您的投资目标、风险承受能力以及交易经验。您的交易亏损有可能超过原始投入。ACY Capital LLC (Company number: 2610 LLC 2022)仅提供一般建议，并未将您的投资目标、财务状况和需求考虑在内。本网站的内容不构成个人投资建议，如有任何疑问，请您咨询独立的财务或税务专家的意见。<a href='/zh/support/terms-and-conditions'>关键信息与条款文件</a>可应要求或在注册时提供。如果本网站上有任何建议，则仅为一般建议。</p>
                <p>ACY Capital LLC (“ACY LLC”) 于圣文森特和格林纳丁斯注册成立（公司编号：2610 LLC 2022）。 注册地址：Suite 305, Griffith Corporate Centre, Beachmont, Kingstown。</p>
                <p>ACY Securities SA Pty Ltd (注册号：2009/008731/07) 受南非金融行业行为监管局 (FSCA: 51008) 监管。注册地址：4 Stan Road, Sandton, Johannesburg, Gauteng, 2196。FSCA 授权我们根据《金融咨询和中介服务》第 8 条提供金融服务。</p>
            
            `,
    },
  },

  id: {
    banner: {
      spin_now: "Putar Sekarang",
      title:
        "Bergabunglah dengan Promosi Putar dan Menang Kami dan Anda Bisa Bawa Pulang Mobil Ikonik, Uang Tunai, atau Emas",
      subtitle: "Gandakan Kesempatan Anda untuk Menang Sebelum Akhir July 2024",
      logo,
      cars: [
        {
          title: "McLaren GT",
          img: bannerMc,
          img_mid: bannerMcMid,
        },
        {
          title: "Mercedes-Benz G-Class",
          img: bannerMercedes,
          img_mid: bannerMercedesMid,
        },
        {
          title: "Audi RS 5 Coupé",
          img: bannerAudi,
          img_mid: bannerAudiMid,
        },
      ],
      lang_select: [
        {
          img: enFlag,
          text: "English",
        },
        {
          img: zhFlag,
          text: "中文",
        },
        {
          img: arFlag,
          text: "العربية",
        },
        {
          img: idFlag,
          text: "Bahasa",
        },
        {
          img: esFlag,
          text: "Español",
        },
        {
          img: viFlag,
          text: "Tiếng Việt",
        },
      ],
    },
    new_prizes: {
      title: "Hadiah baru yang menakjubkan yang membuat pernyataan",
      subtitle:
        'Yang ditawarkan tahun ini adalah McLaren GT yang sangat cantik, Mercedes "G-Class" yang legendaris, Audi RS 5 Coupe yang megah, jam tangan Rolex yang trendi, emas batangan Australia 10 ons, Apple iPhone 16 Pro, dan berbagai hadiah uang tunai sebesar US $30 , US $50, US $100, dan US $500',
      bottom_title: "Setiap putaran memenangkan hadiah",
      bottom_subtitle: "Minimum US $ 30 (dalam mata uang dasar Anda) dijamin",
      spin_now: "Putar Sekarang",
      prizes: [
        smallMc,
        smallMercedes,
        smallAudi,
        smallHublot,
        smallGold,
        smallIphone,
        smallCash,
      ],
    },
    cars: [
      {
        title: "McLaren GT",
        price: "US $224,400*",
        logo: mcLarenLogo,
        img: fixMc,
      },
      {
        title: "Mercedes-Benz G-Class",
        price: "US $149,400*",
        logo: mercedesLogo,
        img: fixMercedes,
      },
      {
        title: "Audi RS 5 Coupé",
        price: "US $80,695*",
        logo: audiLogo,
        img: fixAudi,
      },
    ],
    other_prizes: [
      {
        title: "Submariner Date",
        price: "US$26,000*",
        img: fixHublot,
        logo: rolexLogo,
        class_name: "hublot",
      },
      {
        title: "10 ons Emas",
        price: "US$23,000*",
        img: fixGold,
        logo: goldLogo,
        class_name: "gold",
      },
      {
        title: "iPhone 16 Pro 512GB",
        price: "US$1,300*",
        img: fixIphone,
        logo: iphoneLogo,
        class_name: "iphone",
      },
      {
        title: "Hadiah Tunai",
        price: "US$30, US$50, US$100 danUS$500",
        img: fixCash,
        class_name: "cash",
      },
    ],
    how_to: {
      title: "Cara berpartisipasi dalam Spin & Win",
      subtitle: "Ikuti lima langkah mudah berikut.",
      bottom1:
        "Spin & Win tersedia secara eksklusif untuk klien ACY Securities (ACY LTD) saja.",
      bottom2: "Semua gambar yang ditampilkan hanya untuk tujuan ilustrasi.",
      cards: [
        {
          img: howTo1,
          text: `Jika Anda belum menjadi klien, <a href="${getAcyCloudUrl(
            "id"
          )}" target="__blank">buka akun perdagangan </a>dengan ACY Securities.`,
        },
        {
          img: howTo2,
          text: 'Buat akun Finlogix. <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
        },
        {
          img: howTo3,
          text: "Hubungkan akun Finlogix Anda ke akun perdagangan Sekuritas ACY dengan satu klik sederhana.",
        },
        {
          img: howTo4,
          text: `Setor $ 2000 melalui portal klien<a href="${getAcyCloudUrl(
            "id"
          )}" target="__blank">ACY.Cloud</a>  Anda.`,
        },
        {
          img: howTo5,
          text: `Klik ikon roda di dalam akun <a href="${getAcyCloudUrl(
            "id"
          )}" target="__blank">ACY.Cloud</a>  Anda dan lakukan putaran Anda.`,
        },
      ],
    },
    wheel: {
      lang: "id",
      title: "Putar, untuk memenangkannya",
      subtitle: "Login ke akun ACY Securities Anda atau Daftar.",
      spin: "Putar & Menang",
      login: "Gabung",
      openAccount: "Membuka Akun",
      logout: "Keluar",
      connect_btn: "Terhubung",
      connect:
        "Anda belum terhubung ke Finlogix, silakan klik tombol hubungkan untuk mendaftar ke Finlogix dalam satu langkah mudah",
      hi: "Halo",
      click_btn: "Klik tombol untuk mulai memutar dan menang.",
      left: "",
      you_have: "Kamu Punya",
      chance: "Kesempatan",
      chances: "Peluang",
      spin_min_deposite: "Setoran Minimum Diperlukan",
      spin_prize: "Hadiah",
      special_promo_title: "Penawaran Khusus Putar & Menang",
      special_promo_content: [
        "Periode Penawaran Khusus Putar & Menang berlangsung dari 1/3/2024 hingga 31/7/2024.",
        "Klien yang melakukan deposit $2.000 atau lebih (dalam mata uang dasar akun mereka), akan mendapatkan 1 putaran di bulan yang sama.",
        "Deposit kedua sebesar $2.000 atau lebih (dalam mata uang dasar akun mereka) pada bulan kalender yang sama, akan menghasilkan 1 putaran lagi. Batas 2 putaran per bulan berlaku selama periode promosi ini.",
        "Putaran kedua diberikan dengan syarat dan ketentuan yang sama seperti putaran pertama.",
        "ACY LLC berhak atas penentuan hadiah akhir.",
        "2 putaran per bulan",
        "Kemenangan minimal US$30 per putaran",
        "Setoran minimum bervariasi berdasarkan mata uang dasar akun perdagangan Anda (lihat tabel di atas)",
      ],
      limit: "2 putaran per bulan",
      minimum_win: "Kemenangan minimal US$30 per putaran",
      minimum_deposite:
        "Setoran minimum bervariasi berdasarkan mata uang dasar akun perdagangan Anda (lihat tabel di atas)",
      switch_btn: "Beralih akun untuk berputar",
      // download_Terms: 'Download Terms & Conditions',
      terms: `*<a href='https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms.pdf' target="__blank">Syarat & Ketentuan</a> berlaku. Perdagangan melibatkan risiko. ACY Capital LLC. 2610 LLC 2022. Penduduk Australia tidak memenuhi syarat untuk penawaran ini.`,
      deposit_pop: {
        title: "Oh tidak, Anda belum bisa berputar",
        p1: "Klien yang menyetor setidaknya US $ 2.000 (atau setara) berhak untuk memutar.",
        p2: "Setiap putaran memenangkan hadiah!",
        button: "Lakukan deposit sekarang",
      },
      connect_finlogix_pop: {
        title: "Hubungkan ke Finlogix",
        p1: "Untuk berpartisipasi dalam Spin dan Win 2024, Anda perlu membuat akun dengan Finlogix.",
        p2: "FInlogix adalah komunitas perdagangan sosial gratis untuk pedagang, dan telah bermitra dengan ACY Securities.",
        p3: "Klik tombol di bawah untuk mendaftar ke Finlogix dengan satu langkah mudah. ​​",
        button: "Daftar ke Finlogix",
        lang: "id",
      },
      congratulations_pop: {
        title: "Selamat!",
        subtitle: "Anda Menang",
        p1: "Silakan periksa email Anda untuk mengetahui langkah-langkah selanjutnya untuk mengklaim hadiah Anda.",
      },
      error_messages: {
        "-101": "Sayangnya, promosi ini telah berakhir.",
        "-102":
          "Anda sudah menggunakan peluang untuk undian bulan ini, akan ada kejutan bulan depan!",
        "-103":
          "Hadiah telah diundi. Untuk menghindari ketinggalan, silakan periksa situs web untuk pemberitahuan tentang promosi di masa mendatang!",
        "-105": "server error",
        429: "Terlalu Banyak permintaan",
      },

      not_start: "Waktu mulai kampanye adalah",
      please_wait: "Silahkan tunggu",

      prize_name: {
        mclaren: "McLaren GT",
        audi: "Audi RS 5 Coupé",
        mercedes: "Mercedes-Benz G-Class",
        iphone: "iPhone 16 Pro 512GB",
        watch: "Rolex Submariner Date",
        gold: "10 ons Emas",
        cash30: "Hadiah Uang Tunai US $ 30",
        cash50: "Hadiah Uang Tunai US $ 50",
        cash100: "Hadiah Uang Tunai US $ 100",
        cash500: "Hadiah Uang Tunai US $ 500",
      },
    },
    why_trade: {
      title: "Mengapa berdagang dengan ACY Securities",
      subtitle:
        "Dengan kondisi perdagangan yang tiada duanya, rangkaian sumber daya lengkap untuk membantu Anda tumbuh sebagai pedagang, dan pilihan lebih dari 2,200 instrumen untuk mendiversifikasi portofolio Anda, bergabunglah dengan ACY hari ini dan temukan keunggulan Anda.",
      cards: [
        {
          title: "pemrosesan order super cepat",
          subtitle: "Di bawah 30 ms",
          img: icon1,
        },
        {
          title: "Perdagangan berbiaya sangat rendah",
          subtitle: "Spread mulai 0.0 pip",
          img: icon2,
        },
        {
          title: "Dukungan 24 jam 5 hari kerja",
          subtitle: "Dukungan multibahasa",
          img: icon3,
        },
        {
          title: "Menembus Analisa Pasar",
          subtitle: "Laporan Pagi & Sore",
          img: icon4,
        },
        {
          title: "Copy Trading",
          subtitle: "Salin trader terbaik kami",
          img: icon5,
        },
        {
          title: "Lebih dari 2.200 CFD",
          subtitle: "Berdagang di MT4, MT5, dan ACY Trading Platform",
          img: icon6,
        },
      ],
    },
    reasons5: {
      title: `5 alasan untuk beralih ke ACY hari ini`,
      img: reasonsImg,
      reasons: [
        {
          reason_title: `Trade dengan platform MT5, MT4, dan ACY Trading Platform milik kami`,
          reason_content: `Perdagangkan FX, Logam, dan sampai 2.200 pasar dengan margin dinamis hingga 1:5000`,
        },
        {
          reason_title: `Mulai berdagang spread FX mulai dari nol pip`,
          reason_content: `Spread mulai dari 0,0 pip | Kecepatan eksekusi di bawah 30ms`,
        },
        {
          reason_title: `Dapatkan akses ke alat trading terbaik untuk para trader`,
          reason_content: `Kalender Ekonomi, Capitalise.ai, Skrip MetaTrader Gratis, Forex VPS, Widget Trading, dan lainnya`,
        },
        {
          reason_title: `Tidak ada batasan untuk Expert Adviser (EA) atau trading frekuensi tinggi`,
          reason_content: `Perdagangkan pasar dengan cara Anda sendiri`,
        },
        {
          reason_title: `Copy Trade dengan salah satu alat copy trading terbaik`,
          reason_content: `Pilih dari trader-trader unggulan kami berdasarkan tujuan trading Anda`,
        },
      ],
    },
    sign_up: {
      title: "Belum punya akun dengan kami? Daftar sekarang!",
      open_an_account: "Membuka Akun",
    },
    footer: {
      acyau: [
        "PERINGATAN RISIKO: Perdagangan valuta asing dan derivatif membawa risiko yang signifikan dan tidak cocok untuk semua investor. Anda tidak memiliki, atau memiliki kepentingan dalam, aset yang mendasarinya. Sebelum Anda memutuskan untuk memperdagangkan valuta asing dan derivatif, kami menyarankan Anda untuk mempertimbangkan tujuan investasi Anda, toleransi risiko, dan pengalaman trading Anda. ACY Capital LLC (Nomor perusahaan: 2610 LLC 2022) memberikan saran umum yang tidak mempertimbangkan tujuan, situasi keuangan, atau kebutuhan Anda. Konten situs web ini tidak boleh ditafsirkan sebagai saran pribadi; mohon meminta saran dari penasihat keuangan atau pajak independen jika Anda memiliki pertanyaan. <a href='/id/support/terms-and-conditions'>KIS dan Ketentuan</a> tersedia berdasarkan permintaan atau pendaftaran. Jika ada saran di situs ini, itu adalah saran umum saja.",
        "ACY Securities Pty Ltd (A.B.N 80 150 565 781) diatur oleh Komisi Sekuritas dan Investasi Australia (ASIC AFSL:403863). Alamat terdaftar: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL memberi wewenang kepada kami untuk menyediakan layanan keuangan kepada penduduk atau bisnis Australia. MetaTrader 4 dan MetaTrader 5 milik ACY Securities Pty Ltd adalah perangkat lunak yang disediakan oleh MetaQuotes Ltd.",
        "ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) diatur oleh Otoritas Perilaku Sektor Keuangan (FSCA: 51008). Alamat terdaftar: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA memberi wewenang kepada kami untuk menyediakan layanan keuangan dalam hal bagian 8 dari Layanan Penasihat Keuangan dan Perantara.",
      ],
      acyltd: [
        "PERINGATAN RISIKO: Perdagangan valuta asing dan derivatif membawa risiko yang signifikan dan tidak cocok untuk semua investor. Anda tidak memiliki, atau memiliki kepentingan dalam, aset yang mendasarinya. Sebelum Anda memutuskan untuk memperdagangkan valuta asing dan derivatif, kami menyarankan Anda untuk mempertimbangkan tujuan investasi Anda, toleransi risiko, dan pengalaman trading Anda. ACY Capital LLC (Nomor perusahaan: 2610 LLC 2022) memberikan saran umum yang tidak mempertimbangkan tujuan, situasi keuangan, atau kebutuhan Anda. Konten situs web ini tidak boleh ditafsirkan sebagai saran pribadi; mohon meminta saran dari penasihat keuangan atau pajak independen jika Anda memiliki pertanyaan. <a href='/id/support/terms-and-conditions'>KIS dan Ketentuan</a> tersedia berdasarkan permintaan atau pendaftaran. Jika ada saran di situs ini, itu adalah saran umum saja.",
        "ACY Capital LLC ('ACY LLC') didirikan di St Vincent dan Grenadines (Nomor perusahaan: 2610 LLC 2022). Alamat terdaftar: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.",
        "ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) diatur oleh Otoritas Perilaku Sektor Keuangan (FSCA: 51008). Alamat terdaftar: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA memberi wewenang kepada kami untuk menyediakan layanan keuangan dalam hal bagian 8 dari Layanan Penasihat Keuangan dan Perantara.",
        "Untuk klien Yordania, Al Bilad Securities and Investment Company (Nomor Registrasi: 397, Nomor Institusi: 200027569), yang berlokasi di Gedung 11, Jalan Paris, Al Swifeyeh, Amman, Yordania (Al Bilad), bertindak sebagai broker pengantar untuk ACY Capital Australia LLC (Nomor Perusahaan: 2610 LLC 2022). Al Bilad memiliki lisensi dari Komisi Sekuritas Yordania untuk menyediakan layanan keuangan dengan memperkenalkan klien Yordania kepada broker asing, sementara ACY LLC tetap menjadi penyedia utama dan penerbit produk-produknya.",
      ],
      copyright:
        "© 2018 - 2025 ACY Securities is a brand name of ACY Securities Pty Ltd and ACY Capital LLC. All rights Reserved.",
      tac: "Terms of use ACY Securities Website",
    },
    form: {
      get_started: "Memulai",
      subtitle: "Daftar sekarang untuk kesempatan menang Anda",
      bottom_text: `
                <p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/id/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p>
                <p>ACY Capital LLC ('ACY LLC') is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>
                <p>ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) is regulated by the Financial Sector Conduct Authority (FSCA: 51008). Registered address: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA authorised us to provide financial services in terms of section 8 of the Financial Advisory and Intermediary Services.</p>
            `,
    },
  },

  vi: {
    banner: {
      spin_now: "Tham gia ngay bây giờ",
      title:
        "Tham gia Chương trình Quay và Trúng thưởng của chúng tôi và Bạn Có Thể Mang Về Những Chiếc Siêu Xe, Tiền Mặt hoặc Vàng",
      subtitle:
        "Tăng Cơ Hội Trúng Thưởng của Bạn Trước Khi Hết Tháng 7 Năm 2024",
      logo,
      cars: [
        {
          title: "Xe McLaren GT",
          img: bannerMc,
          img_mid: bannerMcMid,
        },
        {
          title: "Xe Mercedes-Benz G-Class",
          img: bannerMercedes,
          img_mid: bannerMercedesMid,
        },
        {
          title: "Xe Audi RS 5 Coupe",
          img: bannerAudi,
          img_mid: bannerAudiMid,
        },
      ],
      lang_select: [
        {
          img: enFlag,
          text: "English",
        },
        {
          img: zhFlag,
          text: "中文",
        },
        {
          img: arFlag,
          text: "العربية",
        },
        {
          img: idFlag,
          text: "Bahasa",
        },
        {
          img: esFlag,
          text: "Español",
        },
        {
          img: viFlag,
          text: "Tiếng Việt",
        },
      ],
    },
    new_prizes: {
      title: "Những giải thưởng mới lạ và ấn tượng",
      subtitle:
        'Những giải thưởng năm nay vô cùng tuyệt vời như: các dòng xe hơi McLaren GT, Mercedes "G-Class", Audi RS 5 Coupe, đồng hồ Rolex sành điệu,Vàng 10g, iPhone 16 Pro và những giải thưởng tiền mặt giá trị khác (30, 50, 100, 500 USD)',
      bottom_title: "Mỗi lần quay đều thắng",
      bottom_subtitle:
        "Đảm bảo trúng thưởng thấp nhất 30 USD (Dựa vào đơn vị tiền tệ của bạn)",
      spin_now: "Tham gia ngay",
      prizes: [
        smallMc,
        smallMercedes,
        smallAudi,
        smallHublot,
        smallGold,
        smallIphone,
        smallCash,
      ],
    },
    cars: [
      {
        title: "Xe McLaren GT",
        price: "US$224,400*",
        logo: mcLarenLogo,
        img: fixMc,
      },
      {
        title: "Xe Mercedes-Benz G-Class",
        price: "US$149,400*",
        logo: mercedesLogo,
        img: fixMercedes,
      },
      {
        title: "Xe Audi RS 5 Coupe",
        price: "US$76,000*",
        logo: audiLogo,
        img: fixAudi,
      },
    ],
    other_prizes: [
      {
        title: "Submariner Date",
        price: "US$26,000*",
        img: fixHublot,
        logo: rolexLogo,
        class_name: "hublot",
      },
      {
        title: "Vàng 10g",
        price: "US$23,000*",
        img: fixGold,
        logo: goldLogo,
        class_name: "gold",
      },
      {
        title: "iPhone 16 Pro 512GB",
        price: "US$1,300*",
        img: fixIphone,
        logo: iphoneLogo,
        class_name: "iphone",
      },
      {
        title: "Giải thưởng tiền mặt",
        price: "US$30, US$50, US$100, US$500",
        img: fixCash,
        class_name: "cash",
      },
    ],
    how_to: {
      title: "Cách thức tham gia Spin & Win",
      subtitle: "Tiến hành theo 5 bước đơn giản",
      bottom1:
        "Spin & Win chỉ dành riêng cho khách hàng của ACY Securities (ACY LTD)",
      bottom2: "Tất cả hình ảnh hiển thị chỉ mang tính chất minh họa",
      cards: [
        {
          img: howTo1,
          text: `Nếu bạn chưa phải là khách hàng trước đó hãy <a href="${getAcyCloudUrl(
            "vi"
          )}" target="__blank">mở tài khoản giao dịch </a>với ACY Securities`,
        },
        {
          img: howTo2,
          text: 'Tạo tại khoản Finlogix <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
        },
        {
          img: howTo3,
          text: "Kết nối tài khoản Finlogix của bạn với ACY Securities, Chỉ với thao tác nhấp chuột đơn giản",
        },
        {
          img: howTo4,
          text: `Nạp 2000 Đôla thông qua <a href="${getAcyCloudUrl(
            "vi"
          )}" target="__blank">Cổng thông tin Khách hàng ACY</a> của bạn`,
        },
        {
          img: howTo5,
          text: `Nhấp vào biểu tượng bánh xe trong <a href="${getAcyCloudUrl(
            "vi"
          )}" target="__blank">Cổng thông tin Khách hàng ACY</a> của bạn để nhận lượt quay`,
        },
      ],
    },
    wheel: {
      lang: "vi",
      title: "Tham gia ngay và đoạt lấy giải thưởng",
      subtitle:
        "Đăng nhập vào tài khoản chứng khoán ACY của bạn hoặc đăng ký mới",
      spin: "Quay và giành giải thưởng",
      login: "Đăng nhập",
      openAccount: "Mở tài khoản",
      logout: "Đăng xuất",
      connect_btn: "Kết nối",
      connect:
        "Bạn chưa kết nối với Finlogix, vui lòng nhấn vào nút bên dưới để đăng nhập vào Finlogix trong một bước đơn giản",
      hi: "Xin Chào",
      click_btn: "Nhấn vào nút bên dưới và bắt đầu quay và giành giải thưởng",
      left: "",
      you_have: "Bạn có",
      chance: "cơ hội",
      chances: "cơ hội",
      spin_min_deposite: "Tiền gửi tối thiểu bắt buộc",
      spin_prize: "Phần thưởng",
      special_promo_title: "Ưu Đãi Đặc Biệt Quay & Thắng",
      special_promo_content: [
        "Thời gian Ưu Đãi Đặc Biệt Quay & Thắng từ 1/3/2024 đến 31/7/2024.",
        "Khách hàng gửi từ 2.000 USD trở lên (bằng loại tiền cơ bản trong tài khoản của họ) sẽ kiếm được 1 lần quay trong cùng tháng.",
        "Khoản tiền gửi thứ hai từ 2.000 USD trở lên (bằng loại tiền cơ bản trong tài khoản của họ) trong cùng một tháng dương lịch sẽ kiếm được thêm 1 lần quay. Giới hạn 2 lần quay mỗi tháng được áp dụng trong thời gian khuyến mãi này.",
        "Vòng quay thứ hai được cấp theo các điều khoản và điều kiện tương tự như vòng quay đầu tiên.",
        "ACY LLC có quyền quyết định giải thưởng cuối cùng.",
        "2 lần quay mỗi tháng",
        "Tiền thắng tối thiểu là 30 đô la Mỹ cho mỗi lần quay",
        "Tiền gửi tối thiểu thay đổi dựa trên loại tiền tệ cơ bản trong tài khoản giao dịch của bạn (xem bảng ở trên)",
      ],
      limit: "2 lần quay mỗi tháng",
      minimum_win: "Tiền thắng tối thiểu là 30 đô la Mỹ cho mỗi lần quay",
      minimum_deposite:
        "Tiền gửi tối thiểu thay đổi dựa trên loại tiền tệ cơ bản trong tài khoản giao dịch của bạn (xem bảng ở trên)",
      switch_btn: "Chuyển tài khoản để quay",
      // download_Terms: 'Download Terms & Conditions',
      terms: `*<a href="https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms-vi.pdf" target="__blank">Điều khoản và Điều kiện</a> áp dụng. Giao dịch tiềm ẩn rủi ro. ACY Capital LLC. 2610 LLC 2022. Ưu đãi này không áp dụng cho cư dân tại Úc.`,
      deposit_pop: {
        title: "Ôi không! Bạn chưa thể quay ngay bây giờ",
        p1: "Khách hàng tham gia cần gửi đủ số tiền là 2000 đôla (Hoặc tương đương) sẻ đủ điều kiện tham gia vòng quay",
        p2: "Mỗi vòng quay đều giành được giải thưởng!",
        button: "Hãy gửi tiền ngay bây giờ!",
      },
      connect_finlogix_pop: {
        title: "Kết nối với Finlogix ngay",
        p1: "Để tham gia vào Spin and Win 2024, ban cần tạo một tài khoản liên kết với Finlogix",
        p2: "Finlogix là một cộng động giao dịch hoàn toàn miễn phí dành cho các nhà giao dịch và Finlogix đã hợp tác với ACY Securities",
        p3: "Nhấp vào nút bên dưới để đăng ký Finlogix trong một bước đơn giản.",
        button: "Đăng ký Finlogix",
        lang: "vi",
      },
      congratulations_pop: {
        title: "Chúc mừng bạn!",
        subtitle: "Bạn đã giành được",
        p1: "Vui lòng kiểm tra hộp thư của bạn để biết các bước tiếp theo để nhận giải thưởng",
      },
      error_messages: {
        "-101": "Thật không may chương trình khuyến mãi đã kết thúc",
        "-102":
          "Bạn đã sử dụng cơ hội bốc thăm may mắn tháng này, tháng sau sẽ có nhiều bất ngờ cho bạn!",
        "-103":
          "Giải thưởng đã được nhận. Để tránh bỏ lỡ, vui lòng cập nhật thông tin trên trang chủ để biết các thông báo về chương trình khuyến mãi trong tương lai!",
        "-105": "Lỗi máy chủ",
        429: "Quá nhiều yêu cầu",
      },

      not_start: "Thời gian bắt đầu của đợt này là",
      please_wait: "Vui lòng chờ đợi.",

      prize_name: {
        mclaren: "Xe McLaren GT",
        audi: "Xe Audi RS 5 Coupe",
        mercedes: "Xe Mercedes-Benz G-Class",
        iphone: "iPhone 16 Pro 512GB",
        watch: "Rolex Submariner Date",
        gold: "Vàng 10g",
        cash30: "Thưởng tiền mặt 30 đôla",
        cash50: "Thưởng tiền mặt 50 đôla",
        cash100: "Thưởng tiền mặt 100 đôla",
        cash500: "Thưởng tiền mặt 500 đôla",
      },
    },
    spin: {
      title: "Spin it, to win it",
      subtitle: "Login to your ACY Securities account or Register.",
      open_an_account: "Open an account",
      log_in: "Log in",
      tac: "Terms & Conditions",
      bottom1: "Up to two spins per month.",
      bottom1: "Every spin wins a minimum of US$30.",
    },
    why_trade: {
      title: "Lý do đồng hành cùng ACY",
      subtitle:
        "Với các điều kiện giao dịch không ai sánh kịp,Có nguồn tài nguyên đầy đủ để giúp bạn phát triển như một nhà giao dịch chân chính, có nhiều sự lựa chọn với hơn 2,200 công cụ để đa dạng hóa danh mục đầu tư của bạn, hãy tham gia ACY ngay hôm nay và khám phá lợi thế của bạn.",
      cards: [
        {
          title: "Hệ thống xử lý lệnh siêu tốc",
          subtitle: "Dưới 30ms",
          img: icon1,
        },
        {
          title: "Chi phí giao dịch cực thấp",
          subtitle: "Độ chênh lệch từ 0.0 pips",
          img: icon2,
        },
        {
          title: "Hỗ trợ 24/5",
          subtitle: "Hỗ trợ đa ngôn ngữ",
          img: icon3,
        },
        {
          title: "Phân tích Thị trường chuyên sâu",
          subtitle: "Báo cáo mỗi buổi sáng và tối",
          img: icon4,
        },
        {
          title: "Giao dịch sao chép",
          subtitle: "Sap chép các nhà giao dịch hàng đầu",
          img: icon5,
        },
        {
          title: "Hơn 2,200 sản phẩm CFD",
          subtitle: "Giao dịch trên MT4, MT5, ACY Trading Platform",
          img: icon6,
        },
      ],
    },
    reasons5: {
      title: `Có 5 lý do để tham gia ACY ngay hôm nay`,
      img: reasonsImg,
      reasons: [
        {
          reason_title: `Giao dịch trên các nền tảng MT5, MT4 và ACY Trading Platform độc quyền của chúng tôi`,
          reason_content: `Giao dịch Forex, kim loại và hơn 2.200 sản phẩm với mức ký quỹ động lên đến 1:5000`,
        },
        {
          reason_title: `Bắt đầu giao dịch Forex với mức chênh lệch chỉ từ 0 pip`,
          reason_content: `Chênh lệch từ 0.0 pip | Tốc độ khớp lệnh dưới 30ms`,
        },
        {
          reason_title: `Truy cập các công cụ giao dịch tốt nhất cho các nhà đầu tư`,
          reason_content: `Lịch kinh tế, Capitalise.ai, Script MetaTrader miễn phí, Forex VPS, Widgets giao dịch và nhiều hơn nữa`,
        },
        {
          reason_title: `Không giới hạn việc sử dụng Expert Adviser (EA) hay giao dịch tần suất cao`,
          reason_content: `Giao dịch theo cách của bạn`,
        },
        {
          reason_title: `Sao chép giao dịch với công cụ sao chép hàng đầu`,
          reason_content: `Chọn lọc các nhà giao dịch hàng đầu phù hợp với mục tiêu của bạn`,
        },
      ],
    },
    sign_up: {
      title: "Bạn chưa có tài khoản của chúng tôi? Hãy đăng ký ngay!",
      open_an_account: "Mở tài khoản",
    },
    footer: {
      acyau: [
        "CẢNH BÁO RỦI RO: Giao dịch ngoại hối và phái sinh mang rủi ro đáng kể và không phù hợp với tất cả các nhà đầu tư. Bạn không sở hữu hoặc có bất kỳ lợi ích nào đối với các tài sản cơ bản. Trước khi bạn quyết định giao dịch ngoại hối và phái sinh, chúng tôi khuyến khích bạn xem xét mục tiêu đầu tư, khả năng chịu rủi ro và kinh nghiệm giao dịch của bạn. ACY Securities Pty Ltd (AFSL: 403863) cung cấp lời khuyên chung không xem xét mục tiêu, tình hình tài chính hoặc nhu cầu của bạn. Bạn nên xem xét liệu bạn có thuộc Thị trường Mục tiêu của chúng tôi hay không bằng cách xem xét <a href='/en/support/terms-and-conditions'>TMD</a> của chúng tôi và đọc <a href='/en/support/terms-and-conditions'>FSG</a> và <a href='/en/support/terms-and-conditions'>PDS</a> của chúng tôi để đảm bảo bạn hiểu đầy đủ các rủi ro. Nội dung của trang web này không được hiểu là lời khuyên cá nhân; vui lòng tìm kiếm lời khuyên từ một cố vấn tài chính hoặc thuế độc lập nếu bạn có bất kỳ câu hỏi nào.",
        "ACY Securities Pty Ltd (A.B.N 80 150 565 781) được quản lý bởi Ủy ban Chứng khoán và Đầu tư Australia (ASIC AFSL:403863). Địa chỉ đăng ký: ACY Tower, Tầng 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL cho phép chúng tôi cung cấp dịch vụ tài chính cho cư dân và doanh nghiệp Australia. Phần mềm MetaTrader 4 và MetaTrader 5 của ACY Securities Pty Ltd do MetaQuotes Ltd cung cấp.",
        "ACY Securities SA Pty Ltd (Đăng ký: 2009/008731/07) được quản lý bởi Cơ quan Quản lý Ngành Tài chính (FSCA: 51008). Địa chỉ đăng ký: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA đã cấp phép cho chúng tôi cung cấp dịch vụ tài chính theo Điều 8 của Dịch vụ Tư vấn Tài chính và Dịch vụ Trung gian.",
      ],
      acyltd: [
        "CẢNH BÁO RỦI RO: Giao dịch ngoại hối và phái sinh mang rủi ro đáng kể và không phù hợp với tất cả các nhà đầu tư. Bạn không sở hữu hoặc có bất kỳ lợi ích nào đối với các tài sản cơ bản. Trước khi bạn quyết định giao dịch ngoại hối và phái sinh, chúng tôi khuyến khích bạn xem xét mục tiêu đầu tư, khả năng chịu rủi ro và kinh nghiệm giao dịch của bạn. ACY Capital LLC (Số công ty: 2610 LLC 2022) cung cấp lời khuyên chung không xem xét mục tiêu, tình hình tài chính hoặc nhu cầu của bạn. Nội dung của trang web này không được hiểu là lời khuyên cá nhân; vui lòng tìm kiếm lời khuyên từ một cố vấn tài chính hoặc thuế độc lập nếu bạn có bất kỳ câu hỏi nào. <a href='/en/support/terms-and-conditions'>KIS và Điều khoản</a> có sẵn theo yêu cầu hoặc đăng ký. Nếu có bất kỳ lời khuyên nào trên trang web này, đó chỉ là lời khuyên chung.",
        "ACY Capital LLC ('ACY LLC') được thành lập tại St Vincent và Grenadines (Số công ty: 2610 LLC 2022). Địa chỉ đăng ký: Suite 305, Trung tâm doanh nghiệp Griffith, Beachmont, Kingstown.",
        "ACY Securities SA Pty Ltd (Đăng ký: 2009/008731/07) được quản lý bởi Cơ quan Quản lý Ngành Tài chính (FSCA: 51008). Địa chỉ đăng ký: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA đã cấp phép cho chúng tôi cung cấp dịch vụ tài chính theo Điều 8 của Dịch vụ Tư vấn Tài chính và Dịch vụ Trung gian.",
        "Đối với khách hàng Jordan, Công ty Chứng khoán và Đầu tư Al Bilad (Số đăng ký: 397, Số tổ chức: 200027569), có trụ sở tại Tòa nhà số 11, Đường Paris, Al Swifeyeh, Amman, Jordan (Al Bilad), đóng vai trò là nhà môi giới giới thiệu cho ACY Capital Australia LLC (Số công ty: 2610 LLC 2022). Al Bilad được Ủy ban Chứng khoán Jordan cấp phép cung cấp các dịch vụ tài chính bằng cách giới thiệu khách hàng Jordan đến các nhà môi giới nước ngoài, trong khi ACY LLC vẫn là đơn vị chính và nhà phát hành các sản phẩm của mình.",
      ],
      copyright:
        "© 2018 - 2025 ACY Securities is a brand name of ACY Securities Pty Ltd and ACY Capital LLC. All rights Reserved.",
      tac: "Terms of use ACY Securities Website",
    },
    form: {
      get_started: "Khởi động ngay",
      subtitle: "Đăng ký ngay để dành cơ hội chiến thắng",
      bottom_text: `
                <p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/vi/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p>
                <p>ACY Capital LLC ('ACY LLC') is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>
                <p>ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) is regulated by the Financial Sector Conduct Authority (FSCA: 51008). Registered address: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA authorised us to provide financial services in terms of section 8 of the Financial Advisory and Intermediary Services.</p>
            `,
    },
  },

  ar: {
    banner: {
      spin_now: "قم بإجراء السحب الآن",
      title:
        "انضم إلى عرضنا الدوار والفوز ويمكنك الحصول على سيارات أيقونية أو نقدًا أو ذهبًا",
      subtitle: "ضاعف فرصك بالربح حتى نهاية يوليو 2024",
      logo,
      cars: [
        {
          title: "سيارة McLaren GT",
          img: bannerMc,
          img_mid: bannerMcMid,
        },
        {
          title: "سيارة Mercedes-Benz G-Class",
          img: bannerMercedes,
          img_mid: bannerMercedesMid,
        },
        {
          title: "سيارة Audi RS 5 Coupé",
          img: bannerAudi,
          img_mid: bannerAudiMid,
        },
      ],
      lang_select: [
        {
          img: enFlag,
          text: "English",
        },
        {
          img: zhFlag,
          text: "中文",
        },
        {
          img: arFlag,
          text: "العربية",
        },
        {
          img: idFlag,
          text: "Bahasa",
        },
        {
          img: esFlag,
          text: "Español",
        },
        {
          img: viFlag,
          text: "Tiếng Việt",
        },
      ],
    },
    new_prizes: {
      title: "جوائز جديدة مذهلة ستحدث تغييراً لديك",
      // subtitle: '*$500 و\t،$100 ،$50 ،$30 :وجوائز نقدية متعددة Apple iPhone 15 Pro ،أونصات من سبائك الذهب الأسترالية\t 10  ،الأنيقة Hublot ساعة ،Audi RS 5 Coupe السيارة الرائعة،Mercedes "G-Class" الجميلة الآخذة للأنفاس، السيارة الأسطورية McLaren GT في عرض هذا العام: سيارة',
      subtitle:
        'في عرض هذا العام: سيارة McLaren GT الجميلة الآخذة للأنفاس، السيارة الأسطورية Mercedes "G-Class"، السيارة الرائعة Audi RS 5 Coupe، ساعة Rolex الأنيقة، 10 أونصات من سبائك الذهب الأسترالية، Apple iPhone 16 Pro وجوائز نقدية متعددة: $30، $50، $100، و $500',
      bottom_title: "في كل Spin ستربح جائزة",
      bottom_subtitle: "على الأقل 30$ (بعملتك المحلية) مضمومة",
      spin_now: "قم بإجراء السحب الآن",
      prizes: [
        smallMc,
        smallMercedes,
        smallAudi,
        smallHublot,
        smallGold,
        smallIphone,
        smallCash,
      ],
    },
    cars: [
      {
        title: "سيارة McLaren GT",
        price: "$224,400*",
        logo: mcLarenLogo,
        img: fixMc,
      },
      {
        title: "سيارة Mercedes-Benz G-Class",
        price: "$149,400*",
        logo: mercedesLogo,
        img: fixMercedes,
      },
      {
        title: "سيارة Audi RS 5 Coupé",
        price: "$80,695*",
        logo: audiLogo,
        img: fixAudi,
      },
    ],
    other_prizes: [
      {
        title: "Submariner Date",
        price: "$26,000*",
        img: fixHublot,
        logo: rolexLogo,
        class_name: "hublot",
      },
      {
        title: "10 أونصات من الذهب",
        price: "$23,000*",
        img: fixGold,
        logo: goldLogo,
        class_name: "gold",
      },
      {
        title: "iPhone 16 Pro 512GB",
        price: "US$1,300*",
        img: fixIphone,
        logo: iphoneLogo,
        class_name: "iphone",
      },
      {
        title: "جوائز نقدية",
        price: "$30, $50, $100, $500",
        img: fixCash,
        class_name: "cash",
      },
    ],
    how_to: {
      title: "كيفية المشاركة في Spin & Win",
      subtitle: "اتبع هذه الخطوات الخمس السهلة",
      bottom1: "Spin & Win متاح حصراً لعملاء ACY Securities (ACY LTD)",
      bottom2: "جميع الصور المعروضة هي لغرض التوضيح فقط.",
      cards: [
        {
          img: howTo1,
          text: `إذا لم تكن عميلا بالفعل، <a href="${getAcyCloudUrl(
            "ar"
          )}" target="__blank"> فافتح حساب تداول </a> مع ACY Securities`,
        },
        {
          img: howTo2,
          text: 'إنشاء حساب على منصة Finlogix <a href="https://ar.finlogix.com/" target="__blank">ar.finlogix.com</a>',
        },
        {
          img: howTo3,
          text: "قم بربط حسابك في Finlogix بحساب تداول ACY Securities الخاص بك بنقرة واحدة.",
        },
        {
          img: howTo4,
          text: `قم بإيداع 2000$ عن طريق بوابة العميل <a href="${getAcyCloudUrl(
            "ar"
          )}" target="__blank">ACY.Cloud</a>`,
        },
        {
          img: howTo5,
          text: `انقر على رمز العجلة في <a href="${getAcyCloudUrl(
            "ar"
          )}" target="__blank">ACY.Cloud</a> وقم بالـ Spin الخاصة بك`,
        },
      ],
    },
    wheel: {
      lang: "ar",
      title: "أدر العجلة لربح جائزتك.",
      subtitle:
        "قم بتسجيل الدخول إلى حساب ACY Securities الخاص بك أو قم بالتسجيل.",
      spin: "عجلة Spin & Win",
      login: "تسجيل الدخول",
      openAccount: "افتح حساب",
      logout: "تسجيل الخروج",
      connect_btn: "الاتصال",
      connect:
        "لم تقم بالتوصيل مع Finlogix، الرجاء النقر على زر الاتصال للتسجيل في Finlogix في خطوة واحدة بسيطة",
      hi: "مرحباً",
      click_btn: "انقر فوق الزر لبدء الـSpin & Win ",
      left: "",
      you_have: "أنت لديك",
      chance: "فرصة",
      chances: "فرص",
      spin_min_deposite: "الحد الأدنى للإيداع",
      spin_prize: "الجائزة",
      special_promo_title: "عرض خاص للدوران والفوز",
      special_promo_content: [
        "فترة العرض الخاص بالدوران والفوز هي من 1/3/2024 إلى 31/7/2024.",
        "العملاء الذين يقومون بإيداع مبلغ 2,000 دولار أو أكثر (بالعملة الأساسية لحسابهم)، سيحصلون على دورة واحدة في نفس الشهر.",
        "إيداع ثاني بمبلغ 2,000 دولار أو أكثر (بالعملة الأساسية لحسابهم) في نفس الشهر التقويمي، سيمكنك من الحصول على دورة واحدة إضافية. يتم تطبيق حد جولتين شهريًا خلال فترة العرض الترويجي هذه.",
        "يتم منح الدورة الثانية بنفس شروط وأحكام الدورة الأولى.",
        "تحتفظ ACY LLC بالحق في تحديد الجوائز النهائية.",
        "2 دورات شهريا",
        "الحد الأدنى للفوز 30 دولار في الدورة الواحدة",
        "يتغير الحد الأدنى للإيداع حسب العملة الأساسية لحساب التداول الخاص بك (انظر الجدول أعلاه) ",
      ],
      limit: "2 دورات شهريا",
      minimum_win: "الحد الأدنى للفوز 30 دولار في الدورة الواحدة",
      minimum_deposite:
        "يتغير الحد الأدنى للإيداع حسب العملة الأساسية لحساب التداول الخاص بك (انظر الجدول أعلاه) ",
      switch_btn: "قم بتبديل الحساب لبدء اللعب ",
      // download_Terms: 'Download Terms & Conditions',
      terms: `*تطبق<a href='https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms-ar.pdf' target="__blank">الشروط والأحكام</a>. التداول ينطوي على مخاطرة. ACY Capital LLC. 2610 LLC 2022. المقيمون في أستراليا غير مؤهلين لهذا العرض.`,
      deposit_pop: {
        title: "للأسف، لا يمكنك القيام بـ Spin الآن.",
        p1: "العملاء الذين يودعون ما لا يقل عن 2000$ (أو ما يعادلها) مؤهلون للقيام بـ Spin.",
        p2: "كل Spin تربح جائزة",
        button: "قم بالإيداع الآن",
      },
      connect_finlogix_pop: {
        title: "التوصيل مع Finlogix",
        p1: "للمشاركة في Spin & Win 2024، تحتاج إلى إنشاء حساب مع Finlogix.",
        p2: "Finlogix هو مجتمع تداول اجتماعي مجاني للمتداولين، وهو شريك مع ACY Securities.",
        p3: "انقر فوق الزر أدناه للتسجيل في Finlogix في خطوة واحدة بسيطة.",
        button: "التسجيل في Finlogix",
        lang: "ar",
      },
      congratulations_pop: {
        title: "مبروك!",
        subtitle: "لقد فزت بـ",
        p1: "يرجى التحقق من بريدك الإلكتروني لمعرفة الخطوات التالية للمطالبة بجائزتك.",
      },
      error_messages: {
        "-101": "لسوء الحظ، انتهى هذا العرض.",
        "-102":
          "لقد استخدمت بالفعل فرص السحب لهذا الشهر، سيكون هناك مفاجأة الشهر المقبل!",
        "-103":
          "لقد تم سحب الجائزة. كي لا تفوتك الفرص المقبلة، يرجى مراجعة الموقع الإلكتروني للحصول على إشعارات حول العروض المستقبلية!",
        "-105": "خطأ في الخادم",
        429: "طلبات كثيرة",
      },

      not_start: "وقت بدء الحملة هو",
      please_wait: "الرجاء الانتظار",

      prize_name: {
        mclaren: "سيارة McLaren GT",
        audi: "سيارة Audi RS 5 Coupé",
        mercedes: "سيارة Mercedes-Benz G-Class",
        iphone: "iPhone 16 Pro 512GB",
        watch: "Rolex Submariner Date",
        gold: "10 أونصات من الذهب",
        cash30: "جائزة نقدية بقيمة 30$",
        cash50: "جائزة نقدية بقيمة 50$",
        cash100: "جائزة نقدية بقيمة 100$",
        cash500: "جائزة نقدية بقيمة 500$",
      },
    },

    why_trade: {
      title: "لماذا لتداول مع ACY Securities؟",
      subtitle:
        "مع ظروف تداول لا مثيل لها، ستحصل على مجموعة كاملة من المصادر لمساعدتك على تطوير نفسك كمتداول، وأكثر من 2,200 أداة تداول لتنويع محفظتك، انضم إلى ACY اليوم واكتشف المزيد من قدراتك.",
      cards: [
        {
          title: "معالجة الأوامر بسرعة فائقة",
          subtitle: "أقل من 30 ميلي ثانية",
          img: icon1,
        },
        {
          title: "تداول منخفض التكلفة للغاية",
          subtitle: "فروق الأسعار من 0.0 نقطة",
          img: icon2,
        },
        {
          title: "دعم على مدار الساعة 5 أيام في الأسبوع",
          subtitle: "دعم متعدد اللغات",
          img: icon3,
        },
        {
          title: "تحليل متميز للسوق",
          subtitle: "تقارير الصباح وبعد الظهيرة",
          img: icon4,
        },
        {
          title: "التداول بالنسخ",
          subtitle: `انسخ تداولات أفضل المتداولين لدينا`,
          img: icon5,
        },
        {
          title: `أكثر من 2200 عقود مقابل فروقات`,
          subtitle: `تداول على منصة  ميتاتريدر 4 (MT4) وميتاتريدر 5 (MT5) و(ACY Trading Platform)`,
          img: icon6,
        },
      ],
    },
    reasons5: {
      title: `خمسة أسباب للتسجيل في ACY اليوم`,
      img: reasonsImg,
      reasons: [
        {
          reason_title: `تداول باستخدام منصة ميتاتريدر 5 (MT5) وميتاتريدر 4 (MT4) ومنصات (ACY Trading Platform) الخاصة بنا`,
          reason_content: `تداول في سوق الفوركس والمعادن وما يصل إلى 2200 سوق بهامش ديناميكي يصل إلى 1:5000`,
        },
        {
          reason_title: `ابدأ تداول فروق أسعار الفوركس من صفر نقطة`,
          reason_content: `تبدأ فروق الأسعار من 0.0 نقطة | سرعات تنفيذ أقل من 30 مللي في الثانية`,
        },
        {
          reason_title: `احصل على أفضل أدوات التداول للمتداولين`,
          reason_content: `التقويم الاقتصادي، (Capitalise.ai)، نصوص ميتاتريدر (MetaTrader) المجانية، Forex) VPS)، أدوات التداول والمزيد`,
        },
        {
          reason_title: `لا توجد قيود على Expert Advisor) (EAs)) أو التداول عالي التردد`,
          reason_content: `تداول في الأسواق بالطريقة التي تريدها`,
        },
        {
          reason_title: `انسخ التداول باستخدام إحدى أفضل أدوات نسخ التداول`,
          reason_content: `اختر من بين أفضل المتداولين لدينا بناءً على أهدافك التداولية`,
        },
      ],
    },
    sign_up: {
      title: "ليس لديك حساب معنا بعد؟ سجل الآن!",
      open_an_account: "افتح حساب",
    },
    footer: {
      acyau: [
        "تحذير من المخاطر: ينطوي تداول العملات الأجنبية والمشتقات على مخاطر كبيرة ولا يناسب جميع المستثمرين. أنت لا تملك أو لديك أي مصلحة في الأصول الأساسية. قبل أن تقرر تداول العملات الأجنبية والمشتقات، نشجعك على التفكير في أهدافك الاستثمارية وتحملك للمخاطر وتجربة التداول. تقدم شركة ACY Securities Pty Ltd (AFSL: 403863) المشورة العامة التي لا تأخذ بعين الاعتبار أهدافك أو وضعك المالي أو احتياجاتك. يجب عليك التفكير فيما إذا كنت جزءًا من سوقنا المستهدف من خلال مراجعة <a href='/support/terms-and-conditions'>TMD</a> وقراءة <a href='/support/terms-and-conditions'>FSG</a> و <a href='/support/terms-and-conditions'>PDS</a> للتأكد من فهمك الكامل للمخاطر. يجب عدم تفسير محتوى هذا الموقع على أنه نصيحة شخصية؛ يرجى طلب المشورة من مستشار مالي أو ضريبي مستقل إذا كانت لديك أي أسئلة.",
        "تخضع شركة (ACY Securities) Pty Ltd (رقم التسجيل 80 150 565 781) للتنظيم من قبل لجنة الأوراق المالية والاستثمارات الأسترالية (ASIC AFSL:403863). العنوان المسجل: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. وقد خولت لنا (AFSL) تقديم الخدمات المالية للمقيمين أو الشركات الأسترالية. إن برنامجي ميتاتريدر 4 (MT4) وميتاتريدر 5 (MT5) التابعين لشركة (ACY Securities) Pty Ltd عبارة عن برامج تقدمها شركة MetaQuotes) Ltd).",
        " شركة (ACY Securities SA Pty Ltd) (رقم التسجيل: 2009/008731/07) تخضع لتنظيم هيئة إدارة سلوك القطاع المالي (FSCA: 51008). العنوان المسجل: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. رخصة (FSCA) تخولنا لتقديم خدمات مالية وفقاً للمادة 8 من قانون الخدمات المالية والاستشارية والوساطة.",
      ],
      acyltd: [
        "تحذير من المخاطر: ينطوي تداول العملات الأجنبية والمشتقات على مخاطر كبيرة ولا يناسب جميع المستثمرين. أنت لا تملك أو لديك أي مصلحة في الأصول الأساسية. قبل أن تقرر تداول العملات الأجنبية والمشتقات، نشجعك على التفكير في أهدافك الاستثمارية وتحملك للمخاطر وتجربة التداول. تقدم ACY Capital LLC (Company number: 2610 LLC 2022) نصائح عامة لا تأخذ بعين الاعتبار أهدافك أو وضعك المالي أو احتياجاتك. يجب عدم تفسير محتوى هذا الموقع على أنه نصيحة شخصية؛ يرجى طلب المشورة من مستشار مالي أو ضريبي مستقل إذا كانت لديك أي أسئلة. تتوفر <a href='/support/terms-and-conditions'>KIS والشروط</a> عند الطلب أو التسجيل. إذا كانت هناك أي نصيحة على هذا الموقع، فهي نصيحة عامة فقط.",
        "شركة (ACY Capital LLC) (ACY LLC) تم تأسيس في سانت فنسنت وجزر غرينادين (رقم الشركة: 2610 LLC 2022). العنوان المسجل: جناح 305، مركز جريفيث كوربوريت، بيتشمونت، كينجستاون.",
        " شركة (ACY Securities SA Pty Ltd) (رقم التسجيل: 2009/008731/07) تخضع لتنظيم هيئة إدارة سلوك القطاع المالي (FSCA: 51008). العنوان المسجل: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. رخصة (FSCA) تخولنا لتقديم خدمات مالية وفقاً للمادة 8 من قانون الخدمات المالية والاستشارية والوساطة.",
        "بالنسبة للعملاء الأردنيين، تعمل شركة البلاد للأوراق المالية والاستثمار (رقم التسجيل 397، رقم المؤسسة 200027569)، التي تقع في مبنى 11، شارع باريس، الصويفية، عمان، الأردن (البلاد)، كوسيط تعريفي لشركة (ACY Capital Australia LLC) (رقم الشركة: 2610 LLC 2022). شركة البلاد مرخصة من قبل هيئة الأوراق المالية الأردنية لتقديم الخدمات المالية من خلال تعريف العملاء الأردنيين بالوسطاء الأجانب، بينما تظل شركة (ACY LLC) هي الشركة الرئيسية والمصدرة لمنتجاتها.",
      ],
      copyright:
        "© 2018 - 2025 ACY Securities is a brand name of ACY Securities Pty Ltd and ACY Capital LLC. All rights Reserved.",
      tac: "Terms of use ACY Securities Website",
    },
    form: {
      get_started: "البدء",
      subtitle: "سجل الآن للحصول على فرصتك للفوز",
      bottom_text: `
                <p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/ar/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p>
                <p>ACY Capital LLC ('ACY LLC') is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>
                <p>ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) is regulated by the Financial Sector Conduct Authority (FSCA: 51008). Registered address: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA authorised us to provide financial services in terms of section 8 of the Financial Advisory and Intermediary Services.</p>
            `,
    },
  },

  es: {
    banner: {
      spin_now: "Gire Ahora",
      title:
        "Únete a nuestra Promoción de Gira y Gana y podrías llevarte a casa Autos icónicos, Dinero en efectivo o Oro",
      subtitle:
        "Duplica tu oportunidad de ganar antes de finales de julio de 2024",
      logo,
      cars: [
        {
          title: "McLaren GT",
          img: bannerMc,
          img_mid: bannerMcMid,
        },
        {
          title: "Mercedes-Benz G-Class",
          img: bannerMercedes,
          img_mid: bannerMercedesMid,
        },
        {
          title: "Audi RS 5 Coupé",
          img: bannerAudi,
          img_mid: bannerAudiMid,
        },
      ],
      lang_select: [
        {
          img: enFlag,
          text: "English",
        },
        {
          img: zhFlag,
          text: "中文",
        },
        {
          img: arFlag,
          text: "العربية",
        },
        {
          img: idFlag,
          text: "Bahasa",
        },
        {
          img: esFlag,
          text: "Español",
        },
        {
          img: viFlag,
          text: "Tiếng Việt",
        },
      ],
    },
    new_prizes: {
      title: "Nuevos premios impresionantes que hacen una declaración",
      subtitle:
        'Este año se ofrece el increíblemente hermoso McLaren GT, el legendario Mercedes "G-Class", el magnífico Audi RS 5 Coupe, el elegante reloj Rolex, 10 onzas de lingotes de oro Australiano, Apple iPhone 16 Pro y múltiples premios en efectivo de US $ 30. , US $ 50, US $ 100 y US $ 500',
      bottom_title: "Cada giro tiene un premio",
      bottom_subtitle: "Se garantiza un mínimo de US $ 30 (en su moneda base)",
      spin_now: "Gire Ahora",
      prizes: [
        smallMc,
        smallMercedes,
        smallAudi,
        smallHublot,
        smallGold,
        smallIphone,
        smallCash,
      ],
    },
    cars: [
      {
        title: "McLaren GT",
        price: "US $224,400*",
        logo: mcLarenLogo,
        img: fixMc,
      },
      {
        title: "Mercedes-Benz G-Class",
        price: "US $149,400*",
        logo: mercedesLogo,
        img: fixMercedes,
      },
      {
        title: "Audi RS 5 Coupé",
        price: "US $80,695*",
        logo: audiLogo,
        img: fixAudi,
      },
    ],
    other_prizes: [
      {
        title: "Submariner Date",
        price: "US$26,000*",
        img: fixHublot,
        logo: rolexLogo,
        class_name: "hublot",
      },
      {
        title: "10 onzas de Oro",
        price: "US$23,000*",
        img: fixGold,
        logo: goldLogo,
        class_name: "gold",
      },
      {
        title: "iPhone 16 Pro 512GB",
        price: "US$1,300*",
        img: fixIphone,
        logo: iphoneLogo,
        class_name: "iphone",
      },
      {
        title: "Premios en Efectivo",
        price: "US$30, US$50, US$100 y US$500",
        img: fixCash,
        class_name: "cash",
      },
    ],
    how_to: {
      title: "Como particiar en Gire & Gane",
      subtitle: "Siga los siguientes 5 pasos",
      bottom1:
        "Gire & Gane está disponible exclusivamente para clientes de ACY Securities (ACY LTD) únicamente.",
      bottom2:
        "Todas las imágenes que se muestran son solo para fines ilustrativos.",
      cards: [
        {
          img: howTo1,
          text: `Si aún no es cliente, <a href="${getAcyCloudUrl(
            "es"
          )}" target="__blank">abra una cuenta de Trading</a> con ACY Securities.`,
        },
        {
          img: howTo2,
          text: 'Cree una cuenta de Finlogix. <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
        },
        {
          img: howTo3,
          text: "Conecte su cuenta de Finlogix a su cuenta de Trading de ACY Securities con un simple clic.",
        },
        {
          img: howTo4,
          text: `Deposite $2000 a través de su portal de cliente <a href="${getAcyCloudUrl(
            "es"
          )}" target="__blank">ACY.Cloud</a>.`,
        },
        {
          img: howTo5,
          text: `Haga clic en el icono de la rueda dentro de su cuenta de <a href="${getAcyCloudUrl(
            "es"
          )}" target="__blank">ACY.Cloud</a> y gire la rueda.`,
        },
      ],
    },
    wheel: {
      lang: "en",
      title: "Gira para Ganar",
      subtitle: "Ingrese a su cuenta de ACY Securities o registrese",
      spin: "Gire & Gane",
      login: "Ingrese",
      openAccount: "Abra una cuenta",
      logout: "Cerrar sesión",
      connect_btn: "Conectarse",
      connect:
        "No ha conectado Finlogix, haga clic en el botón de conexión para registrarse en Finlogix en un simple paso",
      hi: "Hola",
      click_btn: "Haga clic en el botón para comenzar a girar y ganar.",
      left: "left",
      you_have: "Tienes",
      chance: "Oportunidad",
      chances: "Oportunidades",
      spin_min_deposite: "Depósito mínimo requerido",
      spin_prize: "Premio",
      special_promo_title: "¡Oferta Especial Gira y Gana",
      special_promo_content: [
        "El período de la Oferta Especial Gira y Gana es del 1/3/2024 al 31/7/2024.",
        "Los clientes que depositen $2000 o más (en la moneda base de su cuenta) ganarán 1 giro en el mismo mes.",
        "Un segundo depósito de $2000 o más (en la moneda base de su cuenta) en el mismo mes calendario ganará 1 giro adicional. Durante este período de promoción se aplica un límite de 2 giros por mes.",
        "El segundo giro se otorga bajo los mismos términos y condiciones que el primer giro.",
        "ACY LLC se reserva el derecho de determinar el premio final.",
        "2 giro por mes",
        "Ganancia mínima de US$30 por giro",
        "El depósito mínimo varía según la divisa base de su cuenta de operaciones (consulte la tabla anterior)",
      ],
      limit: "2 giro por mes",
      minimum_win: "Ganancia mínima de US$30 por giro",
      minimum_deposite:
        "El depósito mínimo varía según la divisa base de su cuenta de operaciones (consulte la tabla anterior)",
      switch_btn: "Cambiar cuenta para girar",
      // download_Terms: 'Download Terms & Conditions',
      terms: `*<a href='https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms.pdf' target="__blank">T&Cs</a> aplican. Operar implica riesgos. ACY Capital LLC. 2610 LLC 2022. Los residentes australianos no son elegibles para esta oferta.`,
      deposit_pop: {
        title: "Oh no, todavía no puedes girar",
        p1: "Los clientes que depositen al menos US $ 2,000 (o su equivalente) son elegibles para girar.",
        p2: "¡Cada giro gana un premio!",
        button: "Haz un depósito ahora",
      },
      connect_finlogix_pop: {
        title: "Conectarse a Finlogix",
        p1: "Para participar en el Gire & Gane 2024, debe crear una cuenta con Finlogix.",
        p2: "FInlogix es una comunidad de trading social gratuita para traders y se ha asociado con ACY Securities.",
        p3: "Haga clic en el botón de abajo para registrarse en Finlogix en un simple paso.",
        button: "Regístrese en Finlogix",
        lang: "en",
      },
      congratulations_pop: {
        title: "Felicitaciones!",
        subtitle: "Ha ganado un",
        p1: "Consulte su correo electrónico para conocer los siguientes pasos para reclamar su premio.",
      },
      error_messages: {
        "-101": "Desafortunadamente, esta promoción ha finalizado.",
        "-102":
          "Ya has aprovechado las oportunidades para el sorteo de este mes, ¡habrá una sorpresa el próximo mes!",
        "-103":
          "El premio se ha prolongado. Para evitar perderselo, consulte el sitio web para recibir notificaciones sobre futuras promociones.",
        "-105": "Error de Servidor",
        429: "demasiadas solicitudes",
      },

      not_start: "La hora de inicio de la campaña es",
      please_wait: "Por favor espere",

      prize_name: {
        mclaren: "McLaren GT",
        audi: "Audi RS 5 Coupé",
        mercedes: "Mercedes-Benz G-Class",
        iphone: "iPhone 16 Pro 512GB",
        watch: "Rolex Submariner Date",
        gold: "10 ounces of Gold",
        cash30: "Premio en efectivo de US$30",
        cash50: "Premio en efectivo de US$50",
        cash100: "Premio en efectivo de US$100",
        cash500: "Premio en efectivo de US$500",
      },
    },

    why_trade: {
      title: "Por que operar con ACY Securities",
      subtitle:
        "Con condiciones de trading insuperables, un conjunto completo de recursos para ayudarlo a crecer como trader y una selección de más de 2,200 instrumentos para diversificar su cartera, únase a ACY hoy y descubra su ventaja.",
      cards: [
        {
          title: "Procesamiento De órdenes Ultrarrápido",
          subtitle: "Menos de 30 ms",
          img: icon1,
        },
        {
          title: "Ultra-bajo costo operativo",
          subtitle: "Spreads desde 0.0 pips",
          img: icon2,
        },
        {
          title: "Soporte 24/5",
          subtitle: "Soporte Multi-idioma",
          img: icon3,
        },
        {
          title: "Análisis de mercado",
          subtitle: "Reportes Matutinos y Vespertinos",
          img: icon4,
        },
        {
          title: "Copy Trading",
          subtitle: "Copia a nuestros mejores traders",
          img: icon5,
        },
        {
          title: "Más de 2,200 CFDs",
          subtitle: "Opera en MT4, MT5 y ACY Trading Platform",
          img: icon6,
        },
      ],
    },
    reasons5: {
      title: `5 razones para cambiarte a ACY hoy.`,
      img: reasonsImg,
      reasons: [
        {
          reason_title: `Opera con MT5, MT4 y nuestras plataformas exclusivas ACY Trading Platform`,
          reason_content: `Opera en FX, metales y hasta 2,200 mercados con un margen dinámico de hasta 1:5000`,
        },
        {
          reason_title: `Comienza a operar con spreads de FX desde cero pips`,
          reason_content: `Spreads desde 0.0 pips | Velocidades de ejecución inferiores a 30ms`,
        },
        {
          reason_title: `Accede a las mejores herramientas de trading para traders`,
          reason_content: `Calendario económico, Capitalise.ai, scripts gratuitos de MetaTrader, Forex VPS, widgets de trading y más`,
        },
        {
          reason_title: `Sin restricciones para Asesores Expertos (EAs) o trading de alta frecuencia`,
          reason_content: `Opera en los mercados a tu manera`,
        },
        {
          reason_title: `Copia operaciones con una de las mejores herramientas de copy trading`,
          reason_content: `Selecciona entre nuestros traders de mejor rendimiento según tus objetivos de trading`,
        },
      ],
    },
    sign_up: {
      title: "¿Aún no tienes una cuenta con nosotros? ¡Regístrate ahora!",
      open_an_account: "Open an account",
    },
    footer: {
      acyau: [
        "ADVERTENCIA DE RIESGO: La negociación de divisas y derivados conlleva un riesgo significativo y no es adecuada para todos los inversores. No es propietario ni tiene ningún interés en los activos subyacentes. Antes de decidirse a operar con divisas y derivados, le recomendamos que tenga en cuenta sus objetivos de inversión, su tolerancia al riesgo y su experiencia bursátil. ACY Securities Pty Ltd (AFSL: 403863) brinda asesoramiento general que no tiene en cuenta sus objetivos, situación financiera o necesidades. Debe considerar si forma parte de nuestro mercado objetivo revisando nuestro <a href='/es/support/terms-and-conditions'>TMD</a> y leyendo nuestro <a href='/es/support/terms-and-conditions'>FSG</a> y <a href='/es/support/terms-and-conditions'>PDS</a> para asegurarse de que comprende completamente los riesgos. El contenido de este sitio web no debe interpretarse como asesoramiento personal; si tiene alguna pregunta, solicite el asesoramiento de un asesor financiero o fiscal independiente.",
        "ACY Securities Pty Ltd (A.B.N 80 150 565 781) está regulada por la Comisión Australiana de Valores e Inversiones (ASIC AFSL:403863). Dirección registrada: ACY Tower, Nivel 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL nos autoriza a proporcionar servicios financieros a residentes o negocios australianos. MetaTrader 4 y MetaTrader 5 de ACY Securities Pty Ltd son software proporcionados por MetaQuotes Ltd.",
        "ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) está regulada por la Autoridad de Conducta del Sector Financiero (FSCA: 51008). Dirección registrada: 4 Stan Road, Sandton, Johannesburgo, Gauteng, 2196. La FSCA nos autorizó a prestar servicios financieros en términos de la sección 8 de los Servicios de asesoramiento e intermediación financiera.",
      ],
      acyltd: [
        "ADVERTENCIA DE RIESGO: La negociación de divisas y derivados conlleva un riesgo significativo y no es adecuada para todos los inversores. No es propietario ni tiene ningún interés en los activos subyacentes. Antes de decidirse a operar con divisas y derivados, le recomendamos que tenga en cuenta sus objetivos de inversión, su tolerancia al riesgo y su experiencia bursátil. ACY Capital LLC (número de empresa: 2610 LLC 2022) brinda asesoramiento general que no tiene en cuenta sus objetivos, situación financiera o necesidades. El contenido de este sitio web no debe interpretarse como asesoramiento personal; si tiene alguna pregunta, solicite el asesoramiento de un asesor financiero o fiscal independiente. <a href='/es/support/terms-and-conditions'>El KIS y los Términos</a> están disponibles previa solicitud o registro. Si hay algún consejo en este sitio, es solo un consejo general.",
        "ACY Capital LLC («ACY LLC») está constituida en San Vicente y las Granadinas (número de empresa: 2610 LLC 2022). Dirección registrada: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.",
        "ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) está regulada por la Autoridad de Conducta del Sector Financiero (FSCA: 51008). Dirección registrada: 4 Stan Road, Sandton, Johannesburgo, Gauteng, 2196. La FSCA nos autorizó a prestar servicios financieros en términos de la sección 8 de los Servicios de asesoramiento e intermediación financiera.",
        "Para los clientes jordanos, Al Bilad Securities and Investment Company (Número de registro: 397, Número de institución: 200027569), ubicada en el Edificio 11, Calle París, Al Swifeyeh, Amán, Jordania (Al Bilad), actúa como bróker introductorio para ACY Capital Australia LLC (Número de empresa: 2610 LLC 2022). Al Bilad está licenciada por la Comisión de Valores de Jordania para proporcionar servicios financieros introduciendo a clientes jordanos a brókeres extranjeros, mientras que ACY LLC sigue siendo el principal y emisor de sus productos.",
      ],
      copyright:
        "© 2018 - 2025 ACY Securities is a brand name of ACY Securities Pty Ltd and ACY Capital LLC. All rights Reserved.",
      tac: "Terms of use ACY Securities Website",
    },
    form: {
      get_started: "Empezar",
      subtitle: "Regístrese ahora para tener la oportunidad de ganar",
      bottom_text: `
                <p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/es/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p>
                <p>ACY Capital LLC ('ACY LLC') is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>
                <p>ACY Securities SA Pty Ltd (Reg.: 2009/008731/07) is regulated by the Financial Sector Conduct Authority (FSCA: 51008). Registered address: 4 Stan Road, Sandton, Johannesburg, Gauteng, 2196. FSCA authorised us to provide financial services in terms of section 8 of the Financial Advisory and Intermediary Services.</p>
            `,
    },
  },
};
